import PropTypes from 'prop-types';
import { useMemo } from 'react';
import moment from 'moment';
import { DateTimeComponent } from '../../../../../components/mobileForm/componentsMobileForm/DateTimeComponent';
import { DateComponent } from '../../../../../components/mobileForm/componentsMobileForm/DateComponent';
import { TimeComponent } from '../../../../../components/mobileForm/componentsMobileForm/TimeComponent';
import { CustomCurrencyField } from '../../../../../components/incidentForm/fields/customCurrencyField';

export const EditDateTime = ({ value, onChange }) => {
  const format = 'MMM D, YYYY h:mm A';
  const currentValue = useMemo(() => {
    return moment(value, format).toDate();
  }, [value]);

  const onChangeValue = (newValue) => {
    onChange(moment(newValue).locale('en').format(format));
  };

  return <DateTimeComponent value={currentValue} onChange={onChangeValue} />;
};

export const EditDate = ({ value, onChange }) => {
  const format = 'MMM D, YYYY';
  const currentValue = useMemo(() => {
    return moment(value, format).toDate();
  }, [value]);

  const onChangeValue = (newValue) => {
    onChange(moment(newValue).locale('en').format(format));
  };

  return <DateComponent value={currentValue} onChange={onChangeValue} />;
};

export const EditTime = ({ value, onChange }) => {
  return <TimeComponent value={value} onChange={onChange} block />;
};

export const EditCurrency = ({ value, onChange }) => {
  return <CustomCurrencyField value={value} onChange={onChange} />;
}

EditDateTime.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

EditDate.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

EditTime.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

EditCurrency.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};